import { useLocation } from 'react-router-dom';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { List } from 'foundations-components/transitional/components/List';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { useRawParamsForListRolloutProductUpdates } from '../hooks/useRawParamsForListRolloutProductUpdates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsMessage = ({
  category
}) => {
  const {
    search,
    pathname
  } = useLocation();
  const {
    calendarTimestamp,
    view
  } = useRawParamsForListRolloutProductUpdates();
  const query = view && calendarTimestamp ? `?view=${view}&calendarTimestamp=${calendarTimestamp}` : view ? `?view=${view}` : '';
  return /*#__PURE__*/_jsx(ResultsMessage, {
    illustration: "empty-state-charts",
    illustrationProps: {
      width: 187
    },
    children: search !== '' ? /*#__PURE__*/_jsxs(List, {
      marginBlockEnd: "300",
      children: [category === 'scheduled-for-release' ? /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.noResults.calendarWeekHeader"
        })
      }) : /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.noResults.header"
        })
      }), category === 'all' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.noResults.filters"
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.noResults.newToYouFilters_jsx",
        options: {
          to: `/all${search}`
        },
        elements: {
          Link: RouterLink
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(RouterLink, {
        to: `${pathname}${query}`,
        underline: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.noResults.clear"
        })
      })]
    }) : /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.noResults.header"
      })
    })
  });
};
export default NoResultsMessage;